<template>
  <AppSection id="permissions" :title="$getConst.pages.permission.permissions" type="page">
    <AppSection id="permissions-table" :title="$t($getConst.pages.permission.permissions_per_role)" type="section">

      <!--   number of results and select number of items per page   -->
      <b-row class="my-2">
        <b-col md="6"><strong>{{totalItems}}</strong> {{ $t($getConst.pages.table.results)}}</b-col>
        <b-col md="6">
          <b-form inline class="justify-content-sm-end">
            <label class="mr-sm-2">{{ $t($getConst.pages.table.items_per_page) | capitalize}}:</label>
            <b-form-select
              class="mb-2 mr-sm-2 mb-sm-0 form-control"
              v-model="perPage"
              :options="[ 5, 10, 20, 50]"
              :value="null"
            ></b-form-select>
          </b-form>
        </b-col>
      </b-row>

      <b-table
        :items="items"
        :fields="fields"
        :busy="dataLoading"
        show-empty
        responsive="md"
        table-class="text-center"
      >

        <!--   input to filter permissions   -->
        <template #head(name)="data">
          <b-form-input
            class="text-center"
            v-model="permissionInput"
            size="sm"
            :placeholder="$t($getConst.pages.permission.find_permission) | capitalize"></b-form-input>
        </template>

        <!--   buttons to add or remove permissions   -->
        <template v-for="field in fields" v-slot:[`cell(${field.key})`]="data">
          <b-spinner :id="'spinner-'+data.item.id+'-'+data.value.id" small type="grow" class="d-none" label="Spinning"></b-spinner>
          <b-button
            :id="'permission-role-'+data.item.id+'-'+data.value.id"
            :variant="(data.value.exist || superAdminId === data.value.id) ? 'outline-success' : 'outline-danger'"
            class="border-0"
            :disabled="superAdminId === data.value.id || !hasPermission($getConst.permissions.assignPermissions)"
            @click="updatePermission(data)"
          >
            <i class="fa " :class="(data.value.exist || superAdminId === data.value.id) ? 'fa-check' : 'fa-close'"></i>
          </b-button>
        </template>

        <!--   column of permissions names   -->
        <template #cell(name)="data">
          <div class="text-capitalize font-weight-bold">{{ data.value }}</div>
        </template>

        <!--   message when table is empty   -->
        <template #empty="scope">
          {{$t($getConst.pages.table.no_data_to_show) | capitalize}}
        </template>

      </b-table>


      <b-pagination
        v-on:change="getData($event)"
        :total-rows="this.totalItems"
        :per-page="this.perPage"
        v-model="currentPage"
        :current-page="currentPage"
      />

    </AppSection>

  </AppSection>
</template>

<script>
  import AppSection from "../../components/common/sections/AppSection";
  import {getPermissionsPerRole} from "../../api/permissions.api";
  import {addPermissionToRole, removePermissionFromRole} from "../../api/role.api";
  import {debounce} from "lodash";
  export default {
    name: "index",
    components: {AppSection},
    data() {
      return{
        perPage: 5,
        totalItems: 0,
        currentPage: 1,
        permissionInput: null,
        dataLoading: false,
        items: null,
        fields: [],
        superAdminId: null
      }
    },
    methods: {
      getData(nbPage = 1, perPage = this.perPage) {
        this.dataLoading = true;
        getPermissionsPerRole(nbPage, perPage, this.permissionInput).then(
          (response) => {
            this.items = response.data.data;
            this.currentPage = response.data['current_page'];
            this.totalItems = response.data['total'];
            if (this.items.length) {
              this.fields.push({key: 'name', label: ''});
              Object.keys(this.items[0].roles).forEach(e => {
                if (e.toLowerCase() === this.$getConst.roles.SUPER_ADMIN) {
                  this.superAdminId = this.items[0].roles[e].id
                }
                this.fields.push({key: 'roles.'+e, label: e, sortable: false})
              });
            }
            this.dataLoading = false;
          },
          (error) => {
            this.handleApiError(error);
          }
        )
      },
      updatePermission(rowData) {
        const index = rowData.index;
        const roleId = rowData.value.id;
        const roleExist = rowData.value.exist;
        const roleName = rowData.field.label;
        const permissionId = rowData.item.id;
        const spinnerElement = document.getElementById('spinner-'+permissionId+'-'+roleId);
        const btnElement = document.getElementById('permission-role-'+permissionId+'-'+roleId);

        spinnerElement.classList.toggle('d-none');
        btnElement.classList.toggle('d-none');

        if (roleExist) {
          spinnerElement.classList.toggle('text-success');
          this.removePermission(roleId, permissionId, index, roleName, spinnerElement, btnElement);
        } else {
          spinnerElement.classList.toggle('text-danger');
          this.addPermission(roleId, permissionId, index, roleName, spinnerElement, btnElement);
        }
      },
      addPermission(roleId, permissionId, index, roleName, spinnerElement, btnElement) {
        addPermissionToRole(roleId, permissionId).then(
          () => {
            spinnerElement.classList.toggle('d-none');
            spinnerElement.classList.toggle('text-danger');
            btnElement.classList.toggle('d-none');
            this.items[index].roles[roleName].exist = true;
          },
          (error) => {
            this.handleApiError(error);
          }
        )
      },
      removePermission(roleId, permissionId, index, roleName, spinnerElement, btnElement) {
        removePermissionFromRole(roleId, permissionId).then(
          () => {
            spinnerElement.classList.toggle('d-none');
            spinnerElement.classList.toggle('text-success');
            btnElement.classList.toggle('d-none');
            this.items[index].roles[roleName].exist = false;
          },
          (error) => {
            this.handleApiError(error);
          }
        )
      }
    },
    created() {
      this.getData();
      this.debounceInput = debounce(this.getData, 500);
    },
    watch: {
      permissionInput() {
        this.debounceInput();
      },
      perPage() {
        this.getData();
      }
    }
  }
</script>

<style scoped>

</style>
